module.exports = __webpack_public_path__ + "img/ic_rearrange_arrow.3f1e4b05.svg";